<header class="d-flex d-print-none" role="banner">
  <div class="row">
    <div class="col-6 mr-auto">
      <img alt="République Française - Chorus PRO - avis de publicité : Simplifions la commande publique" class="img-fluid" src="../../../assets/img/Chorus%20Pro%20AvisLogo%20-%20Grand%20-%20LogoJuin2024.svg" />
    </div>
  </div>
  <div id="bloc-user" class="col-3 ml-auto">
    <div class="row">
      <ul style="list-style: none;">
        <li> Structure : {{user.siret}} </li>
        <li> Service : {{user.service}} </li>
        <li> Raison Sociale : {{user.raisonSociale}} </li>
        <li>Connecté le : {{date | date:'short':'Europe/Paris'}} </li>
      </ul>
    </div>
  </div>
  <div class="col-3 d-md-none d-block" id="menuResponsive">
    <button (click)="OpenMenu()" class="hamburger-btn" aria-label="Open Menu">
      <span class="hamburger-btn__icon"></span>
    </button>
  </div>
</header>
